import { useEffect, useState } from 'react';
import './Citacao.css';

const Citacao = () => {

    const gichin = [
        'Karate começa com cortesia e acaba com cortesia.',
        'Karate é uma ajuda à justiça.',
        'Os acidentes surgem da negligência.',
        'Não penses que o treino de Karate é apenas no dojo.',
        'O karate é como água quente. Se não receber calor constante, esfria.',
        'Mude de atitude conforme o adversário.',
        'A derradeira intenção do Karate não está na vitória nem na derrota, mas sim na perfeição de carácter dos seus praticantes.',
        'Ao praticar karate, nunca sinta-se satisfeito, como se tivesse alcançado o suficiente.',
        'Não importa quantos anos você tenha, há sempre algo mais para aprender.',
        'O verdadeiro significado do Karate transcende além das técnicas e métodos. É uma jornada para aperfeiçoar o caráter.',
        'A mente é tudo. O que você pensa, você se torna.',
    ];


    const [fraseAtual, setFraseAtual] = useState('');

    useEffect(() => {
      const fraseAleatoria = gichin[Math.floor(Math.random() * gichin.length)];
      setFraseAtual(fraseAleatoria);
    }, []);



    return (
        <>
            <section id='citacao' name='citacao' class='py-4'>
               <div class="container">
                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-md-5 text-center">
                            <img class="gichin-img" src={`${process.env.PUBLIC_URL}/home/gichin.png`} />
                        </div>
                        <div class="col-md text-center">
                            <h3>"<span class="frase">{fraseAtual}</span>" <br/> <span class="autor">Gichin Funakoshi</span></h3>
                        </div>
                    </div>
               </div>
            </section>
        </>
    )
};


export default Citacao;

